/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-nested-ternary */
import { useLeaflet } from 'react-leaflet';
import L from 'leaflet';
import { Colors } from '@inplayer-org/inplayer-ui';

// utils
import formatNumber from 'utils/formatNumber';

const cssStyle = document.createElement('style');
document.head.appendChild(cssStyle);

const Choropleth = ({
  geoJson,
  featureProp,
  mapDescriptionType,
  coordinates = [
    [0, 0],
    [0, 0],
  ],
  countryCode = () => null,
}) => {
  const { map } = useLeaflet();

  L.geoJson(geoJson).addTo(map);

  const getColor = (d) => {
    return d > 1000
      ? '#800026'
      : d > 500
      ? '#BD0026'
      : d > 100
      ? '#E31A1C'
      : d > 20
      ? '#FC4E2A'
      : d > 10
      ? '#FD8D3C'
      : d > 5
      ? '#FEB24C'
      : d > 1
      ? '#FED976'
      : '#FFEDA0';
  };

  const style = (feature) => {
    return {
      fillColor: getColor(feature.properties[featureProp]),
      weight: 2,
      opacity: 1,
      color: Colors.white,
      fillOpacity: 0.7,
    };
  };

  const gjson = L.geoJson(geoJson, { style }).addTo(map);

  const highlightFeature = (e) => {
    const layer = e.target;

    layer.setStyle({
      weight: 3,
      color: Colors.fontDarkGray,
      dashArray: '',
      fillOpacity: 0.7,
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
    info.update(layer.feature.properties);
  };

  const resetHighlight = (e) => {
    gjson.resetStyle(e.target);
    info.update();
  };

  const areCoordinatesAvailable = coordinates.flat().every((coordinate) => coordinate !== 0);
  if (areCoordinatesAvailable) {
    const corner1Coords = coordinates[0];
    const corner2Coords = coordinates[1];

    const corner1 = L.latLng(corner1Coords[0], corner1Coords[1]);
    const corner2 = L.latLng(corner2Coords[0], corner2Coords[1]);
    const bounds = L.latLngBounds(corner1, corner2);

    map.fitBounds(bounds);
  }

  const zoomToFeature = (e) => {
    map.fitBounds(e.target.getBounds());
    countryCode(e.sourceTarget.feature.properties.iso_a2);
  };

  const onEachFeature = (_, layer) => {
    layer.on({
      mouseover: highlightFeature,
      mouseout: resetHighlight,
      click: zoomToFeature,
    });
  };

  L.geoJson(geoJson, {
    style,
    onEachFeature,
  }).addTo(map);

  const info = L.control();
  info.onAdd = function () {
    this._div = L.DomUtil.create('div', 'info');
    this.update();
    return this._div;
  };

  // Edit info box text and variables (such as props.denisty) to match those in your GeoJSON data
  info.update = function (props) {
    this._div.innerHTML = `<h4>${mapDescriptionType}s per Country</h4>${
      props
        ? `<b>${props.name}</b><br />${formatNumber(props[featureProp])}  ${
            props[featureProp] === 1 ? `${mapDescriptionType.toLowerCase()}` : `${mapDescriptionType.toLowerCase()}s`
          }`
        : 'Hover over a country'
    }`;
  };
  info.addTo(map);

  const legend = L.control({ position: 'bottomright' });

  legend.onAdd = () => {
    const div = L.DomUtil.create('div', 'info legend');
    const grades = [0, 1, 5, 10, 20, 100, 500, 1000];

    // loop through our density intervals and generate a label with a colored square for each interval
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < grades.length; i++) {
      div.innerHTML += `<i id="background_grade_${grades[i]}"></i> ${grades[i]}${
        grades[i + 1] ? `&ndash;${grades[i + 1]}<br>` : '+'
      }`;

      // add background for each legend square
      cssStyle.sheet.insertRule(`#background_grade_${grades[i]} {background:${getColor(grades[i] + 1)}}`);
    }

    return div;
  };

  legend.addTo(map);

  return null;
};

export default Choropleth;
